import { useGraphql } from 'utils/hooks/useGraphql';
import { UseChannelsHookOutput, UseChannelsQueryData } from './types';
import { DEFAULT_CHANNELS, USE_CHANNELS_HOOK_QUERY } from './constants';

export const useChannels = (): UseChannelsHookOutput => {
  const {
    data,
    error: didError,
    isLoading,
  } = useGraphql<UseChannelsQueryData>(USE_CHANNELS_HOOK_QUERY);
  return {
    channels: data?.messageChannels ?? DEFAULT_CHANNELS,
    didError,
    isLoading,
  };
};
